var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutNewStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5419_5535)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9088 1.58115C12.7454 1.22689 12.3909 1 12.0007 1C11.6106 1 11.2561 1.22689 11.0927 1.58115L8.22361 7.80125L1.42136 8.60777C1.03393 8.6537 0.708599 8.92075 0.588041 9.2918C0.467482 9.66284 0.573715 10.0701 0.860145 10.335L5.88922 14.9857L4.55426 21.7043C4.47822 22.087 4.63167 22.4789 4.9473 22.7082C5.26292 22.9375 5.68309 22.9623 6.02352 22.7718L12.0007 19.426L17.9779 22.7718C18.3183 22.9623 18.7385 22.9375 19.0541 22.7082C19.3698 22.4789 19.5232 22.087 19.4472 21.7043L18.1122 14.9857L23.1413 10.335C23.4277 10.0701 23.534 9.66284 23.4134 9.2918C23.2928 8.92075 22.9675 8.6537 22.5801 8.60777L15.7778 7.80125L12.9088 1.58115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_5535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutNewStar);
export default __webpack_public_path__ + "static/media/about-new-star.4dd5c205d3e8ac586bfd4adf6da07ef8.svg";
export { ForwardRef as ReactComponent };